import { CSSObject } from '@chakra-ui/react';

export const ContainerForms: CSSObject = {
  maxW: '500px',
};
